import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { StepConnector, stepConnectorClasses, styled } from "@mui/material";
import { AlertCircle } from "../../icons/alert-circle";
import { CompleteCircle } from "../../icons/complete-circle";
import { ActiveCircle } from "../../icons/active-circle";
import { Circle } from "../../icons/circle";

const QontoConnectorStyled = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: "calc(-50% + 16px)",
        right: "calc(50% + 16px)",
    },
  
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#099250",
        },
    },

    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#06AED4",
        },
    },
    
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#EAECF0",
        borderTopWidth: 3,
        borderRadius: 1,
        ...theme.applyStyles("dark", {
            borderColor: theme.palette.grey[800],
        }),
    },
}));
const QontoStepIconBoxStyled = styled("div")(({ theme }) => ({
    color: "#eaeaf0",
    // display: "flex",
    // height: 22,
    // alignItems: "center",
    // "& .completed": {
    //     color: "#099250",
    //     zIndex: 1,
    //     fontSize: 18,
    //     border: "1px solid #099250",
    //     borderRadius: "50%",
    // },
    // "& .custom-skipped": {
    //     color: "#F29339",
    //     zIndex: 1,
    //     fontSize: 18,
    //     border: "unset",
    //     borderRadius: "50%",
    // },
    // "& .QontoStepIcon-circle.active": {
    //     width: "20px",
    //     height: "20px",
    //     borderRadius: "50%",
    //     border: "1px solid #06AED4",
    // },
    // "& .QontoStepIcon-circle": {
    //     width: "20px",
    //     height: "20px",
    //     borderRadius: "50%",
    //     border: "1px solid #EAECF0",
    // },
}));
function QontoStepIcon(props) {
    const { active, completed, className, skipped = false } = props;

    return (
        <QontoStepIconBoxStyled>
            {active ? (
                <ActiveCircle />
            ) : skipped ? (
                <AlertCircle />
            ) : completed ? (
                <CompleteCircle />
            ) : (
                <Circle />
            )}
        </QontoStepIconBoxStyled>
    );
}
function QontoConnector(props) {
    return <QontoConnectorStyled />;
}

export default function CustomizedStepper({
    successReasons,
    activeStep,
    setActiveStep,
    steps,
}) {
    //   const [activeStep, setActiveStep] = React.useState(1);
    //   const [skipped, setSkipped] = React.useState(new Set());

    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref.current) {
            // const allSkippedNodes = ref.current.querySelectorAll(".MuiStep-root .MuiStepConnector-line");
            const allSkippedNodes =
                ref.current?.querySelectorAll(".MuiStep-root");

            // console.log(allSkippedNodes);

            if (!allSkippedNodes) {
                return;
            }

            for (let index = 0; index < allSkippedNodes?.length; index++) {
                const node = allSkippedNodes[index];

                const lineRoot = node?.querySelector(".MuiStepConnector-root");
                const lineNode = node?.querySelector(".MuiStepConnector-line");

                if (node?.classList?.contains("custom-skipped")) {
                    if (lineNode) {
                        lineNode.style.borderColor = "#F29339"; // Apply red color
                    }

                    if (lineRoot?.classList?.contains("Mui-active")) {
                        
                        if (lineNode) {
                            lineNode.style.borderColor = "#06AED4"; // Apply red color
                        }
                    }
                }else {
                    lineNode?.style?.removeProperty("border-color"); // Remove custom style to revert to CSS default
                }
            }
        }
    });

    const stepClick = (index) => {
        if (steps[index].uploadedDocFile) {
            setActiveStep(index);
        } else if (steps[index].reasonForSkip) {
            setActiveStep(index);
        } else if (index <= activeStep) {
            setActiveStep(index);
        }
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Stepper
                ref={ref}
                activeStep={activeStep}
                alternativeLabel
                connector={<QontoConnector />}
            >
                {steps.map((cStep, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    const stepIconProps = {};

                    if (
                        (cStep.uploadedDocFile &&
                            cStep.uploadedDocFile?.length > 0) ||
                        (cStep.reasonForSkip &&
                            successReasons.indexOf(cStep.reasonForSkip) > -1)
                    ) {
                        stepProps.completed = true;
                        stepProps.className = "completed";
                        labelProps.classes = {
                            alternativeLabel: "completed",
                        };
                        labelProps.StepIconProps = {
                            className: "completed",
                        };
                        stepIconProps.completed = true;
                        stepIconProps.skipped = false;
                    } else {
                        if (cStep.reasonForSkip) {
                            stepProps.completed = false;
                            stepProps.className = "custom-skipped";

                            labelProps.classes = {
                                alternativeLabel: "custom-skipped",
                            };
                            labelProps.StepIconProps = {
                                className: "custom-skipped",
                            };

                            stepIconProps.skipped = cStep.reasonForSkip
                                ? true
                                : false;
                        }
                    }

                    return (
                        <Step
                            sx={{ cursor: "pointer" }}
                            key={cStep.id}
                            {...stepProps}
                            data-value={index}
                            onClick={() => stepClick(index)}
                        >
                            <StepLabel
                                {...labelProps}
                                sx={{
                                    "&.completed":{
                                        cursor:"pointer"
                                    },
                                    "&.custom-skipped":{
                                        cursor:"pointer"
                                    }
                                }}
                                StepIconComponent={(props) => (
                                    <QontoStepIcon
                                        {...props}
                                        {...stepIconProps}
                                    />
                                )}
                            ></StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
}
